$(() => {
	$(function() {
		$( 'html, body' ).animate({
	        scrollTop: $( '.header' ).offset().top
	    }, 0);
	});

	if ($('.js-airport-today').length > 0) {
		$(window).scroll(function () {
			if ($(this).scrollTop() > $('.js-airport-today').position().top) {
				$('.js-airport-today__inner').addClass('sticky');
			} else {
				$('.js-airport-today__inner').removeClass('sticky');
			}

			if ($(this).scrollTop() > $('.js-airport-today').position().top + 400) {
				$('.airport-today__bg').addClass('color');
			} else {
				$('.airport-today__bg').removeClass('color');
			}

			if ($(this).scrollTop() > $('.js-airport-today').position().top + 600) {
				$('.airport-today__header').addClass('visible');
			} else {
				$('.airport-today__header').removeClass('visible');
			}

			if ($(this).scrollTop() > $('.js-airport-today').position().top + 800) {
				$('.airport-today__list li').addClass('visible');
			} else {
				$('.airport-today__list li').removeClass('visible');
			}

			if ($(this).scrollTop() > $('.js-airport-today').position().top + 1000) {
				$('.airport-today__list-number li').addClass('visible');
			} else {
				$('.airport-today__list-number li').removeClass('visible');
			}

			if ($(this).scrollTop() > $('.js-airport-today').position().top + 1200) {
				$('.js-airport-today').addClass('visible-big');
			} else {
				$('.js-airport-today').removeClass('visible-big');
			}
	 	});
	}
});


// WEBPACK FOOTER //
// ./src/scripts/components/airport-today/airport-today.js